import reducer from './reducers';
import * as actions from './actions';
import * as operations from './operations';
import * as selectors from './selectors';
import * as types from './types';

export default reducer;

export {
  actions,
  operations,
  selectors,
  types,
};
